var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MessageForward component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMessageForward extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.0537 2.72276C14.334 2.60668 14.6565 2.67084 14.871 2.88534L22.6749 10.6892C22.958 10.9723 22.9688 11.4278 22.6995 11.724L14.8957 20.3083C14.6872 20.5375 14.3593 20.615 14.0703 20.5033C13.7813 20.3916 13.5907 20.1136 13.5907 19.8037V15.8714H11.9996C9.87914 15.8714 8.6262 16.2362 7.35888 17.0261C6.36878 17.6432 5.38128 18.507 3.99816 19.7168C3.50301 20.15 2.95716 20.6275 2.34233 21.1539C2.08631 21.373 1.71552 21.3945 1.43589 21.2064C1.15626 21.0183 1.03646 20.6667 1.14304 20.347C1.29194 19.9003 1.44344 19.4145 1.60321 18.9022C2.25192 16.8223 3.03691 14.3053 4.33735 12.1921C5.99939 9.49131 8.55676 7.34798 12.7799 7.34798H13.5907V3.41567C13.5907 3.11232 13.7734 2.83885 14.0537 2.72276ZM15.0907 5.22633V8.09798C15.0907 8.51219 14.7549 8.84798 14.3407 8.84798H12.7799C9.19928 8.84798 7.07434 10.6066 5.61484 12.9783C4.61205 14.6078 3.94864 16.4799 3.37795 18.2654C4.59031 17.2074 5.58416 16.3647 6.56547 15.7531C8.11534 14.7871 9.65617 14.3714 11.9996 14.3714H14.3407C14.7549 14.3714 15.0907 14.7072 15.0907 15.1214V17.8638L21.1085 11.2442L15.0907 5.22633Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMessageForward.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageForward.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageForward.prototype, "size", void 0);
if (customElements.get('cat-icon-message-forward') === undefined) {
    customElements.define('cat-icon-message-forward', BlocksIconMessageForward);
}
